if (window.location.hash == '#recover') {
    showRecoverPasswordForm();
} else {
    hideRecoverPasswordForm();
}

if (window.location.hash == '#register') {
    showRegisterForm();
} else {
    hideRegisterForm();
}

function showRecoverPasswordForm() {
    $('.recover-password-form').show();
    $('.login-form').hide();
    window.location.hash = '#recover';
    return false;
}
function hideRecoverPasswordForm() {
    $('.recover-password-form').hide();
    $('.login-form').show();
    window.location.hash = '';
    return false;
}

function showRegisterForm(){
    $('.login-wrapper').hide();
    $('.register-wrapper').show();
    window.location.hash = '#register';
    return false;
}

function hideRegisterForm(){
    $('.register-wrapper').hide();
    $('.login-wrapper').show();
    window.location.hash = '';
    return false;
}

//sign in page show social account when clicked
$(".js-show-social-accounts").click(function (e) {
  e.preventDefault();
  $(".oxi_social_wrapper").slideDown(400);
});